export enum AnalysisTabs {
    PCA = 0,
    Groups,
    Charts,
    Particles,
}